<template lang="pug" src="./hero-home.pug"></template>

<script>
export default {
  props: ['props'],
  methods: {
    btnFunc (i) {
      if (i === '1') {
        this.$router.push('get-started')
      }
    }
  },
  name: 'carrousel',
  data () {
    return {
      swiperOption: {
        autoplay: true,
        loop: true,
        speed: 1500
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero-home.vue?2dc35e42